<form [formGroup]="loginForm" (ngSubmit)="submit()" class="login-form">

  <div class="form-field">
    <label class="form-label">E-mail</label>
    <div class="input-wrapper" [class.input-error]="submitLoginForm && loginForm.controls['email'].errors">
      <input
        data-cy="login-email"
        type="email"
        formControlName="email"
        placeholder="email@gmail.com"
      />
    </div>
    <div class="field-error" *ngIf="submitLoginForm && loginForm.controls['email'].errors">
      <span *ngIf="loginForm.controls['email'].errors['required']">Campo obrigatório.</span>
      <span *ngIf="loginForm.controls['email'].errors['email']">Email inválido.</span>
    </div>
  </div>

  <div class="form-field">
    <label class="form-label">Senha</label>
    <div class="input-wrapper input-with-icon" [class.input-error]="submitLoginForm && loginForm.controls['password'].errors">
      <input
        data-cy="login-senha"
        [type]="showPasswordControl ? 'text' : 'password'"
        formControlName="password"
        placeholder="*************"
      />
      <div class="input-icon-divider"></div>
      <button type="button" class="input-icon-btn" (click)="showPassword()">
        <fa-icon [icon]="showPasswordControl ? faEye : faEyeSlash"></fa-icon>
      </button>
    </div>
    <div class="field-error" *ngIf="submitLoginForm && loginForm.controls['password'].errors">
      <span *ngIf="loginForm.controls['password'].errors['required']">Campo obrigatório.</span>
    </div>
  </div>

  <div class="form-actions">
    <a class="forgot-link" (click)="handleForgotPassword()">Esqueceu a senha?</a>
  </div>

  <button type="submit" class="btn-submit" data-cy="login-entrar">Entrar</button>

</form>

<app-modal #modal [modalConfig]="modalConfig">
  {{ modalMessage }}
</app-modal>
